import React, { useContext, useState, useRef } from "react";
import classNames from "classnames/bind";
import { Chip } from "../../../components";
import Search from "../Search/Search";
import { SearchIcon, FilterIcon } from "../../../components/Icons/Icons";
import styles from "./Header.module.css";
import { CameraContext } from "../../LiveCamera/LiveCamera";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
const Header = ({
  value,
  filter,
  setFilter,
  setValue,
  handleFilter,
  isGroup,
  setIsGroup,
  type = "Other",
  textSearch = true,
  setListCodeCamera,
  setIsVideoAI,
}) => {
  const { isApply, setIsApply, setCurrentPage, setOnThread, isLoadingCamera } =
    useContext(CameraContext);
  const ref = useRef(null);
  const refSearch = useRef(null);
  const [isSearch, setIsSearch] = useState(false);
  const { t } = useTranslation();
  const handleShowSearch = () => {
    setIsSearch(!isSearch);
  };
  const handleClear = (e) => {
    setValue("");
  };
  const handleOnchange = (data) => {
    setValue(data);
  };
  const handleClose = (value) => {
    const data = filter.map((item, index) => {
      // console.log(item);
      if (value === index) {
        if (item.type === "status" && setIsVideoAI) {
          setIsVideoAI(null);
        }
        return {
          ...item,
          code: null,
          name: "",
        };
      } else return item;
    });
    setFilter(data);
  };
  const handleChangeTab = (value) => {
    if (value === "Địa điểm") {
      if (!isLoadingCamera) {
        setIsGroup(false);
        sessionStorage.setItem("isGroup", false);
      }
      if (setOnThread) {
        setOnThread(false);
      }
      if (isApply !== undefined) {
        setIsApply(false);
      }
    } else {
      if (!isLoadingCamera) {
        setIsGroup(true);
        sessionStorage.setItem("isGroup", true);
      }
      if (isApply !== undefined) {
        setIsApply(false);
      }
    }
    if (type === "Stream") {
      setCurrentPage(1);
    }
    if (type === "AI" && type === "Playback") {
      setFilter([
        {
          name: t("location.isRecord"),
          code: 1,
          type: "record",
        },
      ]);
    }
  };
  // React.useEffect(() => {
  //   let handler = (e) => {
  //     if (
  //       !ref?.current?.contains(e.target) && e.target !== refSearch.current
  //     ) {
  //       // // console.log("tung");
  //       setIsSearch(false)
  //     }
  //   };

  //   document.addEventListener("click", handler);

  //   return () => {
  //     document.removeEventListener("click", handler);
  //   };
  // }, []);

  return (
    <>
      <div className={cx("header")}>
        {isSearch ? (
          <Search
            data={value}
            onClear={handleClear}
            onChange={handleOnchange}
            fillOn={type}
            refSearch={refSearch}
            setSearchShow={setIsSearch}
            setListCodeCamera={setListCodeCamera}
          />
        ) : (
          <div className={cx("header-title")}>
           
              <p
                onClick={(e) => handleChangeTab("Nhóm")}
                className={cx("title", isGroup ? "active" : "")}
              >
                {t("location.group")}
              </p>
            
            <p
              onClick={(e) => handleChangeTab("Địa điểm")}
              className={cx("title", isGroup ? "" : "active")}
            >
              {t("location.address")}
            </p>
          </div>
        )}

        <div ref={ref} className={cx("icon")}>
          {textSearch && (
            <span onClick={handleShowSearch}>
              <SearchIcon />
            </span>
          )}
          <span onClick={() => handleFilter([])}>
            <FilterIcon />
          </span>
        </div>
      </div>
      <div className={cx(filter?.length > 0 ? "filter" : "")}>
        {filter &&
          filter?.length > 0 &&
          filter.map((item, index) => {
            if (item.name) {
              return (
                <Chip
                  key={index}
                  onClose={(e) => handleClose(index)}
                  title={item.name}
                  close
                />
              );
            }
            return <React.Fragment key={index}></React.Fragment>;
          })}
      </div>
    </>
  );
};

export default Header;
